module.exports = __webpack_public_path__ + "img/wish-details-background.0f31aa5a.webp";